<template>
    <transition name="fade">
        <div class="ui-alert" v-show="value">
            <transition name="scale">
                <div class="box-wrap" v-show="value">
                    <div class="content">
                        <h1 class="title">{{alertTitle}}</h1>
                        <p class="msg">{{alertMsg}}</p>
                    </div>
                    <div class="btn-wrap">
                        <button class="btn cancel" v-show="hasCancel" @click="handleCancel">{{cancelTxt}}</button>
                        <button class="btn sure" @click="handleSure">{{sureTxt}}</button>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'nfAlert',
  props: {
    // 是否显示提示框
    value: {
      type: Boolean,
      default: false
    },
    // 弹框标题
    alertTitle: {
      type: String,
      default: '积分不足'
    },
    // 弹框内容
    alertMsg: {
      type: String,
      default: ''
    },
    // 取消按钮文本
    cancelTxt: {
      type: String,
      default: '取消'
    },
    // 确认按钮文本
    sureTxt: {
      type: String,
      default: '确定'
    },
    // 是否需要取消按钮
    hasCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 点击取消按钮
    handleCancel (e) {
      this.$emit('input', false)
      this.$emit('clickCancl', e)
    },
    // 点击确定按钮
    handleSure (e) {
      this.$emit('input', false)
      this.$emit('clickSure', e)
    }
  }
}
</script>

<style scoped>
.ui-alert {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}
.ui-alert .box-wrap {
  width: 72%;
  height: auto;
  border-radius: 0.08rem;
  background-color: #ffffff;
  overflow: hidden;
}
.ui-alert .content {
  box-sizing: border-box;
  padding: 0.39rem 0 0.48rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ui-alert .title {
  color: #333333;
  font-size: 0.34rem;
  line-height: 0.48rem;
  font-family: PingFangSC-Semibold;
  margin-bottom: 0.2rem;
  text-align: center;
  font-weight: normal;
}
.ui-alert .msg {
  font-size: 0.28rem;
  text-align: center;
  word-break: break-all;
  color: #666666;
  line-height: 0.43rem;
  padding: 0 0.88rem;
}
.ui-alert .btn-wrap {
  border-top: 1px solid #e5e5e5;
  display: flex;
  width: 100%;
}
.ui-alert .btn {
  height: 0.88rem;
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.36rem;
  line-height: 0.88rem;
  color: #999999;
  text-align: center;
  background: transparent;
}
.ui-alert .btn:active {
  background-color: #e5e5e5;
}
.ui-alert .btn.cancel {
  border-right: 1px solid #e5e5e5;
}
.ui-alert .btn.sure {
  color: #f64e44;
}
.fade-enter-to,
.fade-leave {
  background: rgba(0, 0, 0, 0.5);
}
.fade-enter,
.fade-leave-to {
  background: rgba(0, 0, 0, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.opacity-enter-to,
.opacity-leave {
  opacity: 1;
}
.opacity-enter, .opacity-leave-to {
    opacity: 0;
}
.opacity-enter-active,
.opacity-leave-active {
  transition: all 0.3s;
}
</style>
